import type { UserType } from "@/types/user";

/** Map login/me API user (Payload or auth API) to frontend UserType */
export function toUserType(u: Record<string, unknown> | null): UserType | null {
  if (!u || typeof u !== "object") return null;
  const fullName =
    typeof u.fullName === "string"
      ? u.fullName
      : [u.firstName, u.lastName].filter(Boolean).join(" ") || "";
  return {
    id: String(u.id ?? ""),
    firstName: String(u.firstName ?? ""),
    lastName: String(u.lastName ?? ""),
    fullName,
    email: String(u.email ?? ""),
    phoneNumber: typeof u.phoneNumber === "string" ? u.phoneNumber : undefined,
    country: typeof u.country === "string" ? u.country : undefined,
    state: typeof u.state === "string" ? u.state : undefined,
    city: typeof u.city === "string" ? u.city : undefined,
    pictureURL: typeof u.pictureURL === "string" ? u.pictureURL : undefined,
  };
}
